import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { setErrorMessage } from './error.actions';

export interface ErrorState {
    message: string | undefined;
}

export const defaultState: ErrorState = {
    message: undefined,
};

export default reducerWithInitialState(defaultState).case(setErrorMessage, (_, payload) => ({
    message: payload,
}));
